import React from 'react';
import WtBalTable from '../components/WbalTable';
//import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// import {MdDeleteForever} from 'react-icons/md';
import { API_BASE } from "../apiBase";

const ADMIN_MODE = false;  // change to false to lock
console.log("*** HomePageWtBal loaded");

function HomePageWtBal({ currentAircraft, setWtbalToEdit }) {
  const tail = String(
    currentAircraft?.tailNumber ??
    currentAircraft?.id ??
    currentAircraft?.tail ??
    ""
).trim().toUpperCase();
    console.log("HomePageWtBal function LOADED")

    const protectedAircraft = [
        //"N6727N",
        //"N7117V",
        //"N988BG"
    ];
    const isProtectedAircraft = protectedAircraft.includes(tail);

    const canEditWeightBalance =
        ADMIN_MODE || !isProtectedAircraft;

    console.log("WTBAL LOCK CHECK:", {
        tail,
        ADMIN_MODE,
        protectedAircraft,
        isProtectedAircraft,
        canEditWeightBalance
    });    

    
    const navigate = useNavigate();

    const onEdit = (wtbal) => {
    // fuel rows should go to a separate page that only edits fuel arm
    if (
        wtbal?.kind === "fuel_initial" ||
        wtbal?.kind === "fuel_runup" ||
        wtbal?.kind === "fuel_takeoff"
    ) {
        setWtbalToEdit(wtbal);
        navigate("/edit-fuel-arm");
        return;
    }

    // normal station rows go to the normal edit page
    setWtbalToEdit(wtbal);
    navigate("/edit-wtbal");
};
    const onDelete = async (id) => {
    try {
        const url = `${API_BASE}/api/wtbals?tail=${encodeURIComponent(tail)}&id=${encodeURIComponent(id)}`;
        const res = await fetch(url, { method: "DELETE" });

         if (!res.ok) {
            const text = await res.text().catch(() => "");
            console.error(`Failed delete ${id}: ${res.status} ${text}`);
            return false;
        }
        // success: 200-299 (includes 204)
        return true;
        
    } catch (e) {
        console.error(`Delete exception for ${id}:`, e);
        return false;
        }
    };
   

    return (
        <>
        <article className ="App-article" >
            <WtBalTable 
                //wtbals={wtbals}
                tail={tail}
                onDelete={onDelete}
                onEdit={onEdit}
                canEdit={canEditWeightBalance}
                />
            

        </article>
         
        </>
    );
}


export default HomePageWtBal;